<template>
  <div
    ref="root"
    class="c-list"
  >
    <slot />
    <slot
      name="loading"
      v-if="loading"
    />
  </div>
</template>

<script setup>
import { useScrollParent } from '@/hooks/useScrollParent'
import { useEventListener } from '@vueuse/core'

const props = defineProps({
  loading: { type: Boolean, default: false },
  finished: { type: Boolean, default: false },
  offset: { type: Number, default: 100 }
})
const emit = defineEmits(['load'])

const root = useTemplateRef('root')
const scroller = useScrollParent(root)

const check = () => {
  if (props.loading || props.finished || !scroller.value) return
  const el = scroller.value === window ? document.documentElement : scroller.value
  const scrollBottom = el.scrollHeight - el.scrollTop - el.clientHeight

  if (scrollBottom <= props.offset) {
    emit('load')
  }
}

useEventListener(scroller, 'scroll', check, {
  passive: true
})

defineExpose({ check })

watch(() => props.loading, newVal => {
  if (!newVal) nextTick(() => check())
})
</script>

<style scoped>
</style>
